import { ReactNode } from 'react';

import useStyles from './ControlBar.styles';

export interface IControlBarProps {
  /** Rendered on the right side of the control bar */
  rightControls?: ReactNode;
  /** Rendered on the left side of the control bar */
  leftControls?: ReactNode;
}

const ControlBar = ({ leftControls, rightControls }: IControlBarProps) => {
  const classes = useStyles();

  return (
    <div className={classes.controlBar} data-qa="controlBar">
      <div className={classes.controls}>{leftControls}</div>
      <div className={classes.controls}>{rightControls}</div>
    </div>
  );
};

export default ControlBar;
